import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store/store";
import * as Sentry from '@sentry/browser';
import * as Integrations from '@sentry/integrations';
import "./registerServiceWorker";
import "./quasar";
import "./validations";

Vue.config.productionTip = false;

if (typeof process.env.VUE_SENTRY_DSN !== 'undefined') {
	Sentry.init({
	  dsn: process.env.VUE_SENTRY_DSN,
	  integrations: [new Integrations.Vue({Vue, attachProps: true})],
	});
}

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
